export var CountryStatus;
(function (CountryStatus) {
    CountryStatus["ACTIVE"] = "active";
    CountryStatus["INACTIVE"] = "inactive";
})(CountryStatus || (CountryStatus = {}));
//# sourceMappingURL=AfriexCountry.js.map